/**
 * @typedef LastSectionChildResult An object representing the last child `item` of the rootSection and
 * the child's parent `parent`
 * @property {Object} parent - The parent of the item currently being traversed
 * @property {?Object} item - The current last child as the sections are being traversed
 */

/**
 * @callback lastSectionChildTraversalCallback
 * @param {LastSectionChildResult} - The current param and last child found
 */
/**
 * Search the informations of the last child of a section rootSection while continuing the search
 * as long as the last child is a section with children
 * @param {Object} rootSection - The section to begin the search for
 * @param {lastSectionChildTraversalCallback} [traversalCallback] - A function given the current parent and last child found for each traversal
 * @returns {?LastSectionChildResult}
 */
function getLastChild (rootSection, traversalCallback = () => {}) {
  let currentLastChild = rootSection.children[rootSection.children.length - 1]
  let currentLastChildParent = rootSection
  traversalCallback({ parent: currentLastChildParent, item: currentLastChild })
  while (currentLastChild?.type === 'title' && currentLastChild.children.length !== 0) {
    currentLastChildParent = currentLastChild
    currentLastChild = currentLastChild.children[currentLastChild.children.length - 1]
    traversalCallback({ parent: currentLastChildParent, item: currentLastChild })
  }
  if (currentLastChild) {
    return {
      parent: currentLastChildParent,
      item: currentLastChild,
    }
  } else {
    return null
  }
}

export {
  getLastChild,
}
